/**
 * router.jsx
 *
 * @Author: jruif
 * @Date: 2017/7/21 下午12:22
 */

import createRoutes from 'Common/router/react-router-config';
import extend from 'object-assign';
import Home from './home';
import Notice from 'Main/notice/notice';
import NotFound from 'Main/errorPage/404';
import Details from './details';
import path from 'Assets/svg/svgPath';

/*
 * hideOnSidebar {bool}：是否在Sidebar中显示
 * title {string}: 页面顶部标题
 * subtitle {string}：页面子标题
 * icon {string}：Sidebar中前置icon
 * */
export const allRoutes = {
  index: {
    id: 'index',
    component: Home,
    path: '/index',
    title: '首页',
    exact: true,
  },
  details: {
    id: 'details',
    component: Details,
    path: '/details/:id',
    title: '内容',
  },
};

export const routes = Object.keys(allRoutes).map(id =>
  extend(allRoutes[id], { docTitle: `${allRoutes[id].title} - 客服中心 - 网易号` }),
);

export default function({ ...other }) {
  return createRoutes({
    routes,
    routerDidSwitch() {
      window.neteaseTracker && window.neteaseTracker();
    },
    ...other,
  });
}
